import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { westValleyCityUTConfig } from "./data";

export default function WestValleyCityUTPage() {
  return <CityPageTemplate config={westValleyCityUTConfig} />;
}